// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { TextFileIcon, UploadIcon } from '@/icons';
import {
  StyledUploadImagePlaceholder,
  ImageContainer,
  StyledDownloadButton,
  StyledCrossInCircleIcon,
  StyledDocumentWrapper,
} from './FileUploadStyles';
import { DOCS_MIME_TYPES, MAX_IMAGE_SIZE } from '@/constants/files';
import PureImageUploader from '../PureImageUploader/PureImageUploader';

export interface IFileUpload {
  isLoading?: boolean;
  disabled?: boolean;
  allowClear?: boolean;
  onChange?: (value: File | Blob | null) => void;
  value?: string;
  placeholder?: string;
  acceptance?: string;
  target?: string;
  fileMaxSize?: number;
  children?: JSX.Element;
  withPreview?: boolean;
  maxCount?: number;
  showList?: boolean;
}

const FileUpload = ({
  value,
  onChange,
  target = 'blanc',
  acceptance = DOCS_MIME_TYPES,
  fileMaxSize = MAX_IMAGE_SIZE,
  disabled,
  maxCount,
  showList,
  withPreview = true,
}: IFileUpload) => {
  const { t } = useTranslation(['common']);
  const handleRemove = () => !disabled && onChange && onChange(null);

  return value && withPreview ? (
    <ImageContainer>
      <StyledDocumentWrapper>
        {!disabled && <StyledCrossInCircleIcon onClick={handleRemove} />}
        <StyledDownloadButton href={value} target={target}>
          <TextFileIcon />
        </StyledDownloadButton>
      </StyledDocumentWrapper>
    </ImageContainer>
  ) : (
    <PureImageUploader
      imageMaxSize={fileMaxSize}
      maxCount={maxCount}
      showUploadList={showList}
      acceptance={acceptance}
      disabled={disabled}
      onChange={onChange}
    >
      <StyledUploadImagePlaceholder>
        <UploadIcon />
        {t('file_upload_placeholder', { ns: 'common' })}
      </StyledUploadImagePlaceholder>
    </PureImageUploader>
  );
};

export default FileUpload;
